module.exports = __webpack_public_path__ + "img/logo.bcde113b.png";